import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { GlobalsProvider } from '../../providers/globals/globals';

@Component({
  selector: 'page-card2card',
  templateUrl: 'card2card.html',
})
export class Card2cardPage {

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private iab: InAppBrowser,
    public params: GlobalsProvider
  ) {
    const options: InAppBrowserOptions = {
      zoom: 'no'
    }

    //const browser = this.iab.create('http://abbmigrants.ru', '_self', options);
    //browser.show();

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad Card2cardPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/card2card/card2card.ts